export default __webpack_public_path__ + "c4c009f4c970bf370cedc5fd866fc698.png";